var map = {
	"./Balance": [
		584,
		584
	],
	"./Balance.js": [
		584,
		584
	],
	"./BankVerification": [
		3836,
		836
	],
	"./BankVerification.js": [
		3836,
		836
	],
	"./Bonus": [
		2792,
		612,
		792
	],
	"./Bonus.js": [
		2792,
		612,
		792
	],
	"./CancelWithdrawModal": [
		5988,
		988
	],
	"./CancelWithdrawModal.js": [
		5988,
		988
	],
	"./DocumentSubmitSuccessPopup": [
		6580,
		832
	],
	"./DocumentSubmitSuccessPopup.js": [
		6580,
		832
	],
	"./DocumentUploadStatus": [
		5900,
		900
	],
	"./DocumentUploadStatus.js": [
		5900,
		900
	],
	"./Finance": [
		3760,
		612,
		760
	],
	"./Finance.js": [
		3760,
		612,
		760
	],
	"./GameTransactions": [
		3352,
		612,
		352
	],
	"./GameTransactions.js": [
		3352,
		612,
		352
	],
	"./IdProof": [
		8120,
		207
	],
	"./IdProof.js": [
		8120,
		207
	],
	"./Ledger": [
		6480,
		480
	],
	"./Ledger.js": [
		6480,
		480
	],
	"./NewBankAccount": [
		6820
	],
	"./NewBankAccount.js": [
		6820
	],
	"./NewUpiId": [
		9640
	],
	"./NewUpiId.js": [
		9640
	],
	"./PhoneAndEmail": [
		6564
	],
	"./PhoneAndEmail.js": [
		6564
	],
	"./Profile": [
		576
	],
	"./Profile.js": [
		576
	],
	"./Security": [
		8980
	],
	"./Security.js": [
		8980
	],
	"./Selfie": [
		4996,
		996
	],
	"./Selfie.js": [
		4996,
		996
	],
	"./UpiId": [
		1488,
		488
	],
	"./UpiId.js": [
		1488,
		488
	],
	"./UserProfile": [
		8824
	],
	"./UserProfile.js": [
		8824
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5804;
module.exports = webpackAsyncContext;